<template>
  <div class="accessibility-container exclude-inversion">
    <div class="menu-accessibility" v-show="menuIsOpen">
      <button @click="aumentarFonte">Aumentar Texto<v-icon color="#fff" class="ml-2">fa fa-plus-circle</v-icon></button>
      <button @click="diminuirFonte">
        Diminuir Texto<v-icon color="#fff" class="ml-2">fa fa-minus-circle</v-icon>
      </button>
      <button @click="reiniciarFonte">Texto Original<v-icon color="#fff" class="ml-2">fa fa-retweet</v-icon></button>
      <button @click="toggleHighContrast">Alto Contraste<v-icon color="#fff" class="ml-2">fa fa-adjust</v-icon></button>
    </div>

    <div class="accessibility-icon" @click="toggleMenu">
      <span><v-icon color="#fff">fa fa-universal-access</v-icon></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccessibilityMenu",
  data() {
    return {
      menuIsOpen: false
    };
  },

  methods: {
    toggleMenu() {
      this.menuIsOpen = !this.menuIsOpen;
    },
    aumentarFonte() {
      const elementos = document.querySelectorAll(
        "h1, h2, h3, h4, h5, h6, h7, span, p, li, button, a, .accessibility-text, .v-tab, .center-countdown"
      );
      elementos.forEach(el => {
        const elemento = el;
        const tamanhoAtual = parseFloat(getComputedStyle(elemento).fontSize);
        elemento.style.fontSize = `${tamanhoAtual + 1}px`;
      });
    },
    diminuirFonte() {
      const elementos = document.querySelectorAll(
        "h1, h2, h3, h4, h5, h6, h7, span, p, li, button, a, .accessibility-text, .v-tab, .center-countdown"
      );
      elementos.forEach(el => {
        const elemento = el;
        const tamanhoAtual = parseFloat(getComputedStyle(elemento).fontSize);
        elemento.style.fontSize = `${tamanhoAtual - 1}px`;
      });
    },
    reiniciarFonte() {
      window.location.reload();
    },
    toggleHighContrast() {
      document.documentElement.classList.toggle("high-contrast");
    }
  }
};
</script>

<style scoped>
.accessibility-container {
  position: fixed !important;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999999 !important;
  display: flex;
  align-items: center;
}

.menu-accessibility {
  background-color: #013770;
  color: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  opacity: 0;
  visibility: hidden;
}

.menu-accessibility button {
  margin-bottom: 5px;
  cursor: pointer;
}

.accessibility-icon {
  background-color: #013770;
  color: #fff;
  padding: 14px 18px;
  font-size: 24px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.menu-accessibility {
  transform: translateX(0);
  opacity: 1;
  visibility: visible;
  transition: 0.3s;
  transition: transform 0.3s ease;
}
</style>
